import { NgZone } from '@angular/core';
import { asyncScheduler, SchedulerLike, Subscription } from 'rxjs';

class ZoneScheduler implements SchedulerLike {
    public constructor(
        protected ngZone: NgZone,
        protected scheduler: SchedulerLike,
    ) {}

    public schedule(...args: unknown[]): Subscription {
        return this.ngZone.run<Subscription>(() => {
            // eslint-disable-next-line prefer-spread
            return this.scheduler.schedule.apply(this.scheduler, args);
        });
    }

    public now(): number {
        return this.scheduler.now();
    }
}

class OutsideZoneScheduler extends ZoneScheduler {
    public schedule(...args: unknown[]): Subscription {
        return this.ngZone.runOutsideAngular(() => {
            // eslint-disable-next-line prefer-spread
            return this.scheduler.schedule.apply(this.scheduler, args);
        });
    }
}

export function zoneScheduler(ngZone: NgZone, scheduler: SchedulerLike = asyncScheduler): SchedulerLike {
    return new ZoneScheduler(ngZone, scheduler);
}

export function outsideZoneScheduler(ngZone: NgZone, scheduler: SchedulerLike = asyncScheduler): SchedulerLike {
    return new OutsideZoneScheduler(ngZone, scheduler);
}
